export default "__VITE_ASSET__4YhFK7ZA__"